import { ChangeEvent, Layout, SelectionEvent, SlideoutDecorator } from "@mcleod/components"
import { AutogenLayoutMobileCommMessages } from "./autogen/AutogenLayoutMobileCommMessages"

type mcMessageSlideoutProps = {
    movementId: string,
    tractorId: string,
    selectedDriverId?: string,
    selectedDriverName?: string,
}

export class MobileCommMessages extends AutogenLayoutMobileCommMessages {

    static openSlideout(mcMessageSlideoutProps: mcMessageSlideoutProps) {
        const { movementId, tractorId, selectedDriverId, selectedDriverName } = mcMessageSlideoutProps;
        const layout = Layout.getLayout("lme/dispatch/mobilecomm/MobileCommMessages") as MobileCommMessages;
        layout.addLayoutLoadListener(async () => {
            new SlideoutDecorator({
                layout, title: "Mobile Comm Messages",
                width: "70%", fillVerticalSpace: true,
                overlayProps: { greyedBackground: true },
                doAfterSlideIn: async () => {
                    const mobileCommChat = layout.layoutMobileCommChat;
                    let driverId: string = selectedDriverId;
                    let driver2Id: string = null;
                    if (movementId != null) {
                        await mobileCommChat.sourceMovementEquipment.search({ id: movementId });
                    }
                    if (selectedDriverId == null) {
                        driverId = mobileCommChat.sourceMovementEquipment.activeRow?.get("driver1.id", null);
                        driver2Id = mobileCommChat.sourceMovementEquipment.activeRow?.get("driver2.id", null);
                    } else {
                        mobileCommChat.textboxDriver.text = selectedDriverName;
                    }
                    mobileCommChat.textboxDriver2.visible = driver2Id != null;
                    mobileCommChat.textboxDriver.caption = driver2Id != null ? "Driver One" : "Driver";
                    mobileCommChat.panelMovementInfo.visible = mobileCommChat.textboxTractorid.visible = movementId != null;
                    mobileCommChat.mainDataSource.search({
                        mc_unit_no: `${tractorId},${driverId}${selectedDriverId == null && driver2Id ? `,${driver2Id}` : ""}`,
                        tractor_id: tractorId, driver_id: driverId, driver2_id: driver2Id,
                        message_type: "R,S", from_chat: true
                    });

                    layout.tabsetMessages.addAfterTabSelectionListener((event: SelectionEvent) => {
                        if (event.newSelection == layout.tabTracking) {
                            layout.layoutTrackingHistory.search({ movement_id: movementId, callin_id: tractorId });
                            layout.layoutMovementMap.search({ movement_id: movementId, include_positions: !layout.layoutTrackingHistory.switchPositionCallin.checked });
                            layout.layoutTrackingHistory.switchPositionCallin.addChangeListener((event: ChangeEvent) => {
                                layout.layoutMovementMap.search({ movement_id: movementId, include_positions: !layout.layoutTrackingHistory.switchPositionCallin.checked });
                            });
                        }
                    });
                }
            });
        });
    }

}
